export const HISTOGRAM_CHART_ARIA_LABEL = 'Histogram Chart';
